module.exports = __webpack_public_path__ + "img/bank.f2a19d8c.png";